// adapted from: https://git.hubteam.com/HubSpot/conversations-internal-schema/blob/24c061ac8fe4f3aee9b0a5f69a2d760a19563fd5/static/js/routing-rules/operators/isValid.js
import { List as ImmutableList } from 'immutable';
import count from 'transmute/count';
import { ROUTING_RULE_TYPES } from '../constants/RoutingTypes';
import { getFallback, getTeamIds, getType, getUserIds } from './routingRulesGetters';
const checkIsList = value => ImmutableList.isList(value) || Array.isArray(value);
const checkIds = ids => checkIsList(ids) && count(ids) > 0;
const validUsersAndTeamsRoutingRules = routingRules => checkIds(getUserIds(routingRules)) || checkIds(getTeamIds(routingRules));
const validTeamsOnlyRoutingRules = routingRules => checkIds(getTeamIds(routingRules));
export const isValid = routingRules => {
  if (!routingRules) {
    return false;
  }
  const type = getType(routingRules);
  switch (type) {
    case ROUTING_RULE_TYPES.USERS_AND_TEAMS:
      // if the type is USERS_AND_TEAMS, we know the type is UsersAndTeamsRoutingRules
      return validUsersAndTeamsRoutingRules(routingRules);
    case ROUTING_RULE_TYPES.TEAMS_ONLY:
      return validTeamsOnlyRoutingRules(routingRules);
    case ROUTING_RULE_TYPES.OWNER:
    case ROUTING_RULE_TYPES.AI_CHATBOT:
      return isValid(getFallback(routingRules));
    default:
      return true;
  }
};